module.exports = "img/button-text-italic-on.90a0873.svg";